import { useSearchParams } from 'react-router-dom'

import {
  ReportsViewResults,
  ReportOptionsTypesType,
} from './reports-view-results'

export const ReportsView = () => {
  const [searchParams] = useSearchParams()
  const reportType = searchParams.get('report-type') as ReportOptionsTypesType

  return (
    <div className="p-12 bg-white content-container">
      <div className="lg:flex-row lg:justify-between gap-2">
        <div>
          <h3>
            <span className="tracking-wider font-bold text-xl">Reports</span>
          </h3>
          <p>
            <span className="tracking-wider font-light">
              Please check results preview below
            </span>
          </p>
          <br />
        </div>

        <ReportsViewResults reportType={reportType} />
      </div>
    </div>
  )
}
